import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { hideModal, showModal } from '../../actions/ModalActions';
import * as actions from '../../actions/ProductActions'
import ModalRoot from '../Modal/ModalRoot';
import './style.css'
class ProductDetail extends Component {

    componentDidMount() {
        var { match } = this.props;
        var id = match.params.id;
        this.props.getProductItem(id)
    }

    showListImage = (imgs) => {
        if (imgs) {
            return imgs.map((item, index) => {
                return (
                    <p style={{ textAlign: 'center', marginTop: '15px' }} key={index} className="product__item--img">
                        <img src={item} alt="" />
                    </p>
                )
            })
        }
    }

    closeModal = () => {
        this.props.hideModal();
    }

    openModalDelete = (product) => {
        this.props.showModal({
            open: true,
            closeModal: this.closeModal,
            product: product
        }, 'alert');
        // this.props.history.push("/products")
    }

    render() {
        var { product } = this.props;
        return (
            <div className="product__detail-page pt-2 pb-3">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="account__page--title">Product Detail</h3>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="product__item--detail page__detail--content">
                                <h3 className="product__item--detail-desc">MÔ TẢ SẢN PHẨM</h3>
                                <div className="product__item--detail-wrapper">
                                    <p className="product__item--detail-name mt-2 mb-2">
                                        Tên sản phẩm:
                                        <span>
                                            {product ? product.name : "Name"}
                                        </span>
                                    </p>
                                    <p className="product__item--detail-name mt-2 mb-2">
                                        Chất liệu: <span>
                                            {product ? product.material : "Material"}
                                        </span>
                                    </p>
                                    <p className="product__item--detail-name">
                                        Hình ảnh sản phẩm
                                    </p>
                                    <div className="product__item--list-img">
                                        {this.showListImage(product ? product.img : [])}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="page__detail--actions mt-5">
                                <h3 className="page__detail--actions-title">Actions: </h3>
                                <Link to={`/product/${product.id}/edit`}
                                    className="btn btn-outline-info btn-edit mr-3"
                                // onClick={() => this.openModal(blog)}
                                >Edit
                                </Link>
                                <button
                                    className="btn btn-outline-warning btn-delete"
                                    onClick={() => this.openModalDelete(product)}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalRoot hideModal={this.props.hideModal} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        product: state.products.productItem
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getProductItem: (id) => {
            dispatch(actions.fetchAPIProductItem(id))
        },
        showModal: (modalProps, modalType) => {
            dispatch(showModal({ modalProps, modalType }))
        },
        hideModal: () => {
            dispatch(hideModal())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);
